import { render, staticRenderFns } from "./ChatLanguageSelection.vue?vue&type=template&id=1cc2e1a8"
import script from "./ChatLanguageSelection.vue?vue&type=script&lang=js"
export * from "./ChatLanguageSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports